import { render, staticRenderFns } from "./ArticleViewer.vue?vue&type=template&id=4c9d1cef&scoped=true&"
import script from "./ArticleViewer.vue?vue&type=script&lang=js&"
export * from "./ArticleViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArticleViewer.vue?vue&type=style&index=1&id=4c9d1cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d1cef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VChip,VCol,VContainer,VImg,VRow})
